module.exports = __webpack_public_path__ + "assets/images/entertainment_phase3.7247dbcea74c20e33124008c518f92c3.svg";